import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'
import { ManagementReport } from '@fortem-monorepo/web-sdk'

export const useManagementReportQuery = (params?: ManagementReport.GetManagementReportParams) => {
  const api = useApi()

  return useQuery({
    queryKey: ['management-report', params],
    queryFn: () => api.managementReport.getReport(params!),
    enabled: !!params?.fund_name && !!params?.value_date,
  })
}
